import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {IncidentRecord} from "../../../NIBINInterface";
import {DataChangeRequestService} from "../../../services/DataChangeRequest.service";
import {IncidentService} from "../../../services/incident.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-view-incident-record',
  templateUrl: './view-incident-record.component.html',
  styleUrls: ['./view-incident-record.component.css'],
  providers: [DataChangeRequestService,IncidentService]
})
export class ViewIncidentRecordComponent implements OnInit {

  constructor(private route: ActivatedRoute, private dataChangeRequestService:DataChangeRequestService ,private incidentService: IncidentService, private router: Router) { }
   IncidentID: string | null = null;
   BatchID: string | null = null;
   OriginalIncident: IncidentRecord | null = null;
   NewIncidentRecord: IncidentRecord | null = null;
  ngOnInit(): void {
    this.route.params.subscribe((param : Params) => {
      console.log(param)
      this.IncidentID = param.IncidentID
      this.BatchID = param.BatchID
      if(this.IncidentID && this.BatchID){
        this.incidentService.getIncident(this.IncidentID).then((r)=>{
          if(r?.length > 0)
            this.OriginalIncident = r[0];

          console.log(this.OriginalIncident)
        });

        this.dataChangeRequestService.GetPendingIncidentRecord(this.IncidentID,this.BatchID).then((r)=>{
          this.NewIncidentRecord = r;
          console.log(this.NewIncidentRecord)
        })


      }
    });
  }

}
